import {
  RecordShareEngagementAction,
  RecordShareEntity,
} from '@monetize/types/app';
import { useEffect } from 'react';
import { useTrackRecordShareAction } from '../../api/shareService';

const getRecordViewedStorageKey = (token: string) => `record_viewed_${token}`;

export const useRecordShareTrackView = (
  tenantId: string,
  recordId: string,
  token: string,
  entity: RecordShareEntity,
) => {
  const { mutate: trackRecordShareAction } = useTrackRecordShareAction({
    onSuccess: () => {
      sessionStorage.setItem(getRecordViewedStorageKey(token), 'true');
    },
  });

  useEffect(() => {
    const hasAlreadyTrackedView = !!sessionStorage.getItem(
      getRecordViewedStorageKey(token),
    );
    if (hasAlreadyTrackedView) {
      return;
    }
    trackRecordShareAction({
      action: RecordShareEngagementAction.VIEWED_RECORD,
      entity,
      recordId,
      tenantId,
      token,
      /** email */
    });
  }, [recordId, tenantId, token, trackRecordShareAction, entity]);
};
